export const showInImmersiveReader = "bbb";
export default {showInImmersiveReader};